/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import './list_statements';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "sfs": {
        "nested": {
          "external": {
            "nested": {
              "service": {
                "nested": {
                  "StatementService": {
                    "methods": {
                      "ListStatements": {
                        "requestType": ".squareup.sfs.external.service.ListStatementsRequest",
                        "responseType": ".squareup.sfs.external.service.ListStatementsResponse"
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.sfs?.nested?.external?.nested?.service?.nested?.StatementService) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc External RPCs for Savings Customers
 * --
 *
 * SOURCE StatementService @ squareup/sfs/external/services/statement/statement_service.proto at 11:1
 */
export const StatementService = $root.lookupService('squareup.sfs.external.service.StatementService');